module.exports = __webpack_public_path__ + "img/Impiegata-ristorazione-AB-015.5cd88111.jpg";